export const betInputPlusOrMinus = {
  minus: '-',
  plus: '+',
};
